import { useQuery } from '@tanstack/react-query';

import { STAFF_KEYS } from '@/constants/queryKeys';
import { errorUtils } from '@/services/errors';
import { staffService } from '@/services/staff';
import { useStaffSession } from '@/hooks/auth';

const useStaffFactors = () => {
  const { data: session } = useStaffSession();

  return useQuery({
    queryKey: STAFF_KEYS.factors(),
    queryFn: async () => errorUtils.unwrap(await staffService.listFactors()),
    enabled: session?.stage === 'ready',
  });
};

export {
  useStaffFactors,
};
